var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FancySelect',_vm._g({attrs:{"options":_vm.campaigns,"loading":_vm.loading,"value":_vm.selectValue,"placeholder":"Select campaign","multiple":_vm.multiple,"title":_vm.campaigns.length === 0 && !_vm.department ? 'Select department first' : null}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }